export const MetaTitles = {
  home: () => 'EveAnalytics™',
  studyList: () => 'Study List',
};
